const CENTS_PER_DOLLAR = 100;
const DOLLARS_PATTERN = /^(\d+)(?:\.(\d{1,2}))?$/;

// Parses a dollar amount with up to two decimals into integer cents.
// Uses string math so "0.07" stays exact. Returns null for bad input.
export function dollarsToCents(text: string): number | null {
  const match = DOLLARS_PATTERN.exec(text.trim());
  if (!match) return null;
  const whole = Number(match[1]);
  const fraction = Number((match[2] ?? '').padEnd(2, '0'));
  const cents = whole * CENTS_PER_DOLLAR + fraction;
  return Number.isSafeInteger(cents) ? cents : null;
}

// Formats cents as a dollar string without trailing zeros.
export function centsToDollars(cents: number): string {
  const whole = Math.floor(cents / CENTS_PER_DOLLAR);
  const fraction = String(cents % CENTS_PER_DOLLAR).padStart(2, '0').replace(/0+$/, '');
  return fraction ? `${whole}.${fraction}` : String(whole);
}

// Formats cents as a US dollar amount, like $1,234.56. Returns a dash for no value.
export function formatCentsAsDollars(cents: number | null | undefined): string {
  if (cents == null) return '—';
  return (cents / CENTS_PER_DOLLAR).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
